
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c-1.266 0-2.277.797-3.094 1.781-.816.985-1.496 2.242-2.062 3.594C9.707 12.078 9 15.075 9 17c0 1.328.121 2.64.656 3.813.442.968 1.274 1.75 2.344 2.312V25c0 1.094.906 2 2 2l1 1h2l1-1c1.094 0 2-.906 2-2v-1.875c1.07-.563 1.902-1.344 2.344-2.313.535-1.171.656-2.484.656-3.812 0-1.926-.707-4.922-1.844-7.625-.566-1.352-1.246-2.61-2.062-3.594C18.277 4.797 17.266 4 16 4zm0 2c.39 0 .945.316 1.563 1.063.617.746 1.23 1.859 1.75 3.093C20.348 12.625 21 15.613 21 17c0 .344-.008.684-.031 1H11.03a13.741 13.741 0 01-.03-1c0-1.387.652-4.375 1.688-6.844.519-1.234 1.132-2.347 1.75-3.094C15.055 6.316 15.608 6 16 6zm-4.5 14h9c-.344.734-.84 1.266-1.844 1.625l-.656.219V25h-4v-3.156l-.656-.219c-1.004-.36-1.5-.89-1.844-1.625z"}})])
          )
        }
      }
    